export class Formatter {
    // 1 = jan
    static month(index) {
        const monthNames = ["januari", "februari", "maart", "april", "mei", "juni",
            "juli", "augustus", "september", "oktober", "november", "december"
        ];
        return monthNames[index - 1];
    }
    static weekDay(date) {
        const monthNames = ["zondag", "maandag", "dinsdag", "woensdag", "donderdag", "vrijdag", "zaterdag"];
        return monthNames[date.getDay()];
    }
    /**
     * 1 januari (2020)
     */
    static date(date) {
        const currentYear = new Date().getFullYear();
        const year = date.getFullYear();
        return date.getDate() + " " + this.month(date.getMonth() + 1) + (currentYear != year ? (" " + year) : "");
    }
    /**
     * maandag, 1 januari (2020)
     */
    static dateWithDay(date) {
        return this.weekDay(date) + ", " + this.date(date);
    }
    /**
     * maandag, 1 januari (2020)
     */
    static dateTimeWithDay(date) {
        return this.weekDay(date) + ", " + this.dateTime(date);
    }
    /**
    * 01/01/2020
    */
    static dateNumber(date) {
        const year = date.getFullYear();
        return (date.getDate() + "").padStart(2, "0") + "/" + ((date.getMonth() + 1) + "").padStart(2, "0") + "/" + year;
    }
    /**
     * 2020-01-31
     */
    static dateIso(date) {
        const year = date.getFullYear();
        return year + "-" + ((date.getMonth() + 1) + "").padStart(2, "0") + "-" + (date.getDate() + "").padStart(2, "0");
    }
    /**
     * 12:00
     */
    static time(date) {
        return date.getHours() + ":" + (date.getMinutes() + "").padStart(2, "0");
    }
    /**
     * 12:00
     */
    static timeIso(date) {
        return (date.getHours() + "").padStart(2, "0") + ":" + (date.getMinutes() + "").padStart(2, "0");
    }
    static uniqueArray(array) {
        function onlyUnique(value, index, self) {
            return self.indexOf(value) === index;
        }
        return array.filter(onlyUnique);
    }
    /**
     * 1 januari (2020) om 12:00. Year only in different year
     */
    static dateTime(date) {
        return this.date(date) + ", " + this.time(date);
    }
    static price(value) {
        const formatted = new Intl.NumberFormat("nl-BE", {
            style: "currency",
            currency: "EUR",
        }).format(Math.abs(value) / 100);
        return formatted.replace(new RegExp("EUR", "ig"), '€');
    }
    static capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    static removeAccents(name) {
        name = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        return name;
    }
    static slug(name) {
        return this.removeAccents(name).replace(/[^A-Za-z0-9]+/g, " ").trim();
    }
}
//# sourceMappingURL=Formatter.js.map